import React from "react";
import { motion } from "framer-motion";
import QuestionnaireBuilder from "../Components/DynamicQuestionnaire/admin/QuestionnaireBuilder";

/**
 * TestAdmin Page
 * A test environment for the administrative components of the dynamic questionnaire system
 */
const TestAdmin = () => {
  return (
    <div className="bg-[#111111] min-h-screen">
      <div className="container mx-auto px-4 py-8">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
        >
          <div className="mb-8">
            <h1 className="text-3xl font-bold text-white mb-4">
              Questionnaire Admin Test
            </h1>
            <p className="text-gray-300 mb-8">
              This is a test environment for the questionnaire admin components.
              Create and manage questionnaires here.
            </p>
          </div>

          <div className="bg-gray-900 rounded-lg p-6">
            <QuestionnaireBuilder />
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default TestAdmin;
